var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"right"}},[_c('div',{staticClass:"bottom"},[_c('keep-alive',{attrs:{"include":_vm.componentId}},[_c(_vm.componentId,{tag:"component"})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }